import { cn } from '@/lib/utils';

interface SvgProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  stroke?: string;
}

export const SnacbarIcon = ({
  className,
  width = '20',
  height = '18',
  stroke = '#fff',
}: SvgProps) => (
  <div className={cn(className)}>
    <svg
      width={width}
      height={height}
      //viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.26356 11.4388L4.32121 11.42C3.47635 11.3921 2.67592 11.0348 2.09098 10.4246C1.50605 9.81432 1.18302 8.99947 1.19093 8.15418C1.19883 7.3089 1.53705 6.50023 2.13329 5.90101C2.72954 5.3018 3.53651 4.95956 4.38175 4.94745L6.32479 4.96482L6.26356 11.4388ZM6.26356 11.4388C10.0613 11.4727 13.7638 12.6315 16.9033 14.7687L17.8758 15.4307L18.0158 1.19076L17.0302 1.83341C13.8504 3.91293 10.1254 5.0029 6.32622 4.96551L6.26356 11.4388ZM6.26356 11.4388C6.25541 12.2865 6.41962 13.1269 6.74622 13.9092C7.07282 14.6914 7.555 15.3991 8.16347 15.9893"
        stroke={stroke}
        strokeWidth="2.38157"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
